import customers from './customers'
import shop from './shop'
import myOrders from './my-orders'

export default [
  {
    path: '/forms',
    name: 'forms',
    meta: {
      authRequired: true
    },
    component: () => import('@/router/views/sales/dashboard/index')
  },
  {
    path: '/sales',
    name: 'sales',
    meta: {
      authRequired: true
    },
    component: () => import('@/router/views/sales/dashboard/index')
  },
  //...customers,
  ...shop,
  ...myOrders,
  {
    path: '/sales/products',
    name: 'sales.products',
    meta: {
      authRequired: true
    },
    props: {
      isSellable: true
    },
    component: () => import('@/router/views/products/list/sales.index')
  }
]
